<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";

/**
 * Vertical Admin Layout - Thiết kế hiện đại, giữ nguyên logic menu cũ
 */
export default {
  components: { NavBar, SideBar, RightBar, Footer },
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null || null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      isMenuCondensed: false,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");

    // Áp dụng màu nền quản trị
    document.body.style.backgroundColor = "var(--color-admin-bg, #f4f6f8)";
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    // Preloader logic (reserved for future use)
  },
};
</script>

<template>
  <div>
    <div id="layout-wrapper">

      <!-- Sidebar -->
      <NavBar @toggle-menu="toggleMenu" @toggle-right-bar="toggleRightSidebar" />
      <SideBar
        :is-condensed="isMenuCondensed"
        :type="leftSidebarType"
        :width="layoutWidth"
      />

      <!-- Main content area - giữ class gốc để tương thích SideBar CSS -->
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid" style="padding: 0px">
            <slot />
          </div>
        </div>
        <!-- Footer -->
        <Footer />
      </div>

      <!-- Right Sidebar Drawer -->
      <RightBar @hide-right-bar="hideRightSidebar" />
    </div>
  </div>
</template>

<style>
/* =========================================
   ADMIN VERTICAL LAYOUT - GLOBAL STYLES
   Áp dụng không scoped để tương thích với
   các class body toggle (sidebar-enable, v.v.)
   ========================================= */

/* Root wrapper */
.admin-layout-root {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-admin-bg, #f4f6f8);
  font-family: var(--font-body, "Inter"), sans-serif;
}

/* Flex container chứa sidebar + nội dung chính */
#layout-wrapper.admin-layout-wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  align-items: stretch;
}

/* Khu vực bên phải: Navbar + Content + Footer */
.admin-main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background-color: var(--color-admin-bg, #f4f6f8);
  min-height: 100vh;
  transition: margin-left 0.3s ease;
}

/* Nội dung trang */
.admin-page-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

@media (min-width: 992px) {
  .admin-page-content {
    padding: 32px;
  }
}

.admin-content-container {
  max-width: 100%;
  margin: 0;
  padding: 0;
}

/* Page transition animation */
.admin-fade-enter-active,
.admin-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.admin-fade-enter {
  opacity: 0;
  transform: translateY(8px);
}

.admin-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Tương thích với header image styling cũ */
.header-item img {
  margin-top: 13px;
}

/* =========================================
   RESPONSIVE: Mobile Sidebar Overlay
   Khi sidebar-enable được toggle trên mobile
   ========================================= */
@media (max-width: 991px) {
  body.sidebar-enable #layout-wrapper::before {
    content: "";
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 90;
    pointer-events: none;
  }
}
</style>
